import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const gstinStateMatchValidator: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {

    const gstin = control.get('gstin')?.value;
    const stateCode = control.get('address')?.get('stateCode')?.value;

    if (!gstin || !stateCode) return null;

    const gstStateCode = gstin.substring(0, 2);

    return gstStateCode !== stateCode.toString()
        ? { stateMismatch: true }
        : null;
};
